// extracted by mini-css-extract-plugin
module.exports = {"brandImage":"ProductBrandSideDrawer_brandImage__KYgj0","productBrand":"ProductBrandSideDrawer_productBrand__jdr4_"};